import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridCompatibilityRoutingModule } from './grid-compatibility-routing.module';
import { SharedModule } from '../+shared/shared.module';
import { EnvironmentService } from '../services/environment.service';
import { HttpClient } from '@angular/common/http';
import { NetzTranslationLoader } from '../services/netz-translation-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  CalendarModule,
  CheckboxModule,
  DropdownModule,
  FileUploadModule,
  InputNumberModule,
  InputSwitchModule,
  InputTextModule,
  InputTextareaModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  TooltipModule,
} from 'primeng';
import { GridCompPersonalDataFormComponent } from './personal-data-form/grid-comp-personal-data-form.component';
import { GridCompDocumentsFormComponent } from './documents-form/grid-comp-documents-form.component';
import { GridCompatibilityService } from './services/grid-compatibility.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { GridCompatibilityAssessmentResultComponent } from './components/grid-compatibility-assessment-result/grid-compatibility-assessment-result.component';
import { ResultFormComponent } from './result-form/result-form.component';
import { GridApplicationSharedModule } from '../+grid-application-shared/grid-application-shared.module';
import { GridApplicationService } from '../+grid-application-shared/services/grid-application.service';
import { GridCompTechnicalFormComponent } from './technical-form/grid-comp-technical-form.component';
import { GridCompatibilityCommentsService } from './services/grid-compatibility-comments.service';
import { GridApplicationCommentsService } from '../+grid-application-shared/services/grid-application-comments.service';

@NgModule({
  declarations: [
    GridCompPersonalDataFormComponent,
    GridCompDocumentsFormComponent,
    GridCompatibilityAssessmentResultComponent,
    ResultFormComponent,
    GridCompTechnicalFormComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    GridCompatibilityRoutingModule,
    SharedModule,
    DropdownModule,
    InputTextModule,
    InputNumberModule,
    RadioButtonModule,
    FileUploadModule,
    CheckboxModule,
    TooltipModule,
    ButtonModule,
    InputSwitchModule,
    InputTextareaModule,
    CalendarModule,
    QuillModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: NetzTranslationLoader,
        deps: [HttpClient, EnvironmentService],
      },
    }),
    ProgressSpinnerModule,
    GridApplicationSharedModule,
  ],
  providers: [
    GridCompatibilityService,
    {
      provide: GridApplicationService,
      useClass: GridCompatibilityService,
    },
    GridCompatibilityCommentsService,
    {
      provide: GridApplicationCommentsService,
      useClass: GridCompatibilityCommentsService,
    },
  ],
})
export class GridCompatibilityModule {}
